import { Button, Modal, ModalBody, ModalDialog, ModalHeader, ModalTitle } from '@ax/ui';
import useAnalytics from '@/hooks/useAnalytics.tsx';
import { ChangeEvent, useEffect, useState } from 'react';

export interface CareCuesUploadModalProps {
  modalOpen?: boolean;
  modalClose?: () => void;
  onUploadAnyway?: (doNotShowAgain: boolean) => void;
  onReviewReminders?: (doNotShowAgain: boolean) => void;
  noteId: string;
}

const CareCuesUploadModal = ({
  modalOpen = false,
  modalClose,
  onUploadAnyway,
  onReviewReminders,
  noteId,
}: CareCuesUploadModalProps) => {
  const analytics = useAnalytics();

  const [doNotShowAgain, setDoNotShowAgain] = useState(false);

  const handleCheckboxChange = (e: ChangeEvent<HTMLInputElement>) => {
    setDoNotShowAgain(e.target.checked);
  };

  useEffect(() => {
    if (modalOpen) {
      analytics.onUploadCareCuesModalTriggered({ noteId });
    }
  }, [modalOpen]);

  const handleModalClose = () => modalClose?.();

  const handleUploadAnyway = () => {
    analytics.onUploadedNoteFromCareCuesUploadModal({ noteId });
    onUploadAnyway?.(doNotShowAgain);
    modalClose?.();
  };

  const handleReviewReminders = () => {
    analytics.onNavigatedToCareCuesFromCareCuesUploadModal({ noteId });
    onReviewReminders?.(doNotShowAgain);
    modalClose?.();
  };

  return (
    <Modal onShow={modalOpen}>
      <ModalDialog>
        <ModalHeader onHide={handleModalClose}>
          <ModalTitle>Review CareCues</ModalTitle>
        </ModalHeader>
        <ModalBody>
          You have open CareCues to review. Addressing CareCues improves note content.
          <br />
          <div className="flex flex-col items-center justify-center">
            <div className="flex items-center my-4 space-x-2">
              <input
                id="doNotShowCheckbox"
                type="checkbox"
                onChange={handleCheckboxChange}
              />
              <label htmlFor="doNotShowCheckbox">Do not show this again</label>
            </div>
            <Button
              className="h-[40px] mt-[10px]"
              variant="primary"
              block
              type="submit"
              onClick={handleReviewReminders}
            >
              Review Now
            </Button>
            <Button
              className="h-[40px] mt-[10px]"
              variant="plain"
              block
              type="submit"
              onClick={handleUploadAnyway}
            >
              Skip Review and Upload
            </Button>
          </div>
        </ModalBody>
      </ModalDialog>
    </Modal>
  );
};

export default CareCuesUploadModal;
